import React from 'react'
import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'
import { createClient } from 'graphql-ws'
import {setContext} from 'apollo-link-context'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'


const httpURI = process.env.REACT_APP_SERVER_URL
const wsURI = process.env.REACT_APP_WS_URL

const token = localStorage.getItem('bqq-token')
const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        'Apollo-Require-Preflight': 'true',
        Authorization: token || '',
        Accept: 'application/json'
      }
    }
})
const httpLink = new HttpLink({
  uri: httpURI,
  cors: 'cors',
  credentials: 'omit',
  referrerPolicy:'strict-origin-when-cross-origin'
})

const wsLink = new GraphQLWsLink(createClient({
  url: wsURI,
  connectionParams: {
    authToken: token
  }
}))

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  wsLink,
  authLink.concat(httpLink)
)

const cache = new InMemoryCache()

const memoryCache = new InMemoryCache({
  possibleTypes: {
    xyz: ["abc", "def"],
  },
}).restore(cache)

const client = new ApolloClient({
    cache: memoryCache,
    link: splitLink,
    resolvers: {},
    connectToDevTools: true,
    cors: {
      origin: true,
      credentials: true, // true if you need cookies/authentication
      methods: ['GET', 'POST', 'PUT', 'OPTIONS']
    }
})

export default client
